import { render, staticRenderFns } from "./NewSupsisTable.vue?vue&type=template&id=5c58f7aa&scoped=true"
import script from "./NewSupsisTable.vue?vue&type=script&lang=js"
export * from "./NewSupsisTable.vue?vue&type=script&lang=js"
import style0 from "./NewSupsisTable.vue?vue&type=style&index=0&id=5c58f7aa&prod&lang=scss&scoped=true"
import style1 from "./NewSupsisTable.vue?vue&type=style&index=1&id=5c58f7aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c58f7aa",
  null
  
)

export default component.exports